export default {
  bind (el, binding) {
    if (binding.value.url) {
      el.addEventListener('click', () => {
        const a = document.createElement('a')
        const url = binding.value.url
        fetch(url).then(res => res.blob()).then(blob => {
          a.href = URL.createObjectURL(blob)
          console.log(a.href)
          console.log(binding)
          a.download = binding.value.name || ''
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(a.href)
          document.body.removeChild(a)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/downLoadUrl/downLoad.js